export const EMAIL_BUILDER_TEMPLATE_NAME_MAX_LENGTH = 255;

export type TEmailBuilderTemplateNameValidation =
  | { ok: true; name: string }
  | { ok: false; error: string };

export function validateEmailBuilderTemplateName(
  rawName: string,
): TEmailBuilderTemplateNameValidation {
  const name = rawName.trim();

  if (name.length === 0) {
    return { ok: false, error: "Template name is required." };
  }

  if (name.length > EMAIL_BUILDER_TEMPLATE_NAME_MAX_LENGTH) {
    return {
      ok: false,
      error: `Template name must be ${EMAIL_BUILDER_TEMPLATE_NAME_MAX_LENGTH} characters or fewer.`,
    };
  }

  return { ok: true, name };
}
